"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// export const PHONE = '320px'
exports.TABLET_PORTRAIT = '@media (min-width: 641px)';
exports.TABLET_LANDSCAPE = '@media (min-width: 900px)';
exports.DESKTOP = '@media (min-width: 1400px)';



// WEBPACK FOOTER //
// ./src/components/styled/ScreenSizes.ts